// extracted by mini-css-extract-plugin
export default {"createdOn_card":"CreatedOnComponent_createdOn_card__HmeLv"};